import { Avatar, Box, Typography } from '@mui/material'
import ErrorTenantCodeSvg from 'src/assets/error_tenant_code.svg'
import { useIntl } from '@frontend/t7nd'

export const NoTenantMessages = {
  TENANT_NOT_EXIST: {
    id: '当前租户信息不存在',
    defaultMessage: '当前租户信息不存在',
  },
  REENTER_LOGIN_ADDRESS: {
    id: '请重新输入企业登录地址',
    defaultMessage: '请重新输入企业登录地址',
  },
} as const

export function NoTenantMessage() {
  const { formatMessage } = useIntl()

  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        gap: '40px',
      }}
    >
      <Box>
        <Typography variant="h2">
          {formatMessage(NoTenantMessages.TENANT_NOT_EXIST)}
        </Typography>
        <Typography
          variant="h5"
          color={(theme) => theme.palette.text.secondary}
        >
          {formatMessage(NoTenantMessages.REENTER_LOGIN_ADDRESS)}
        </Typography>
      </Box>

      <Avatar
        src={ErrorTenantCodeSvg}
        sx={{
          width: '436px',
          height: '436px',
        }}
      />
    </Box>
  )
}
